const adminModelCallLogs = {
  actions: {
    open: '打开 {{requestId}} 的操作菜单',
    refresh: '刷新',
    view: '查看',
  },
  advancedFilters: {
    done: '完成',
    title: '更多筛选',
  },
  columnSelector: {
    label: '选择调用日志列表列',
    trigger: '列',
  },
  description: '查看模型网关 runtime 调用的路由、计费、fallback、quota 和失败信息。',
  drawer: {
    completionTokens: '输出 tokens',
    copyFailed: '复制失败，请手动复制',
    copyRequestId: '复制 Request ID',
    copySuccess: 'Request ID 已复制',
    errorMessage: '错误信息',
    fallbackReason: 'Fallback 原因',
    finalModel: '最终模型',
    finishedAt: '结束时间',
    inputCost: '输入成本',
    interfaceType: '上游接口',
    keyId: '密钥 ID',
    outputCost: '输出成本',
    outputProtocol: '输出协议',
    pricingSource: '计价来源',
    promptTokens: '输入 tokens',
    quotaAction: 'Quota 动作',
    quotaMessage: 'Quota 消息',
    quotaMetric: 'Quota 指标',
    quotaRule: 'Quota 规则',
    requestId: 'Request ID',
    requestedModel: '请求模型',
    resolvedModel: '解析模型',
    routeKind: '路由类型',
    sections: {
      basic: '基础信息',
      controls: 'Fallback 与 quota',
      failure: '失败诊断',
      key: '密钥与计价',
      route: '模型路由',
      usage: '用量与成本',
    },
    title: '调用详情 / {{requestId}}',
  },
  empty: '暂无调用日志',
  errorCategories: {
    auth_error: '认证失败',
    expired_key: '密钥过期',
    internal_error: '内部错误',
    model_not_allowed: '模型未授权',
    probe_failed: '探针失败',
    protocol_mismatch: '协议不匹配',
    quota_exceeded: '超出 quota',
    stream_denied: '禁止流式',
    upstream_4xx: '上游 4xx',
    upstream_5xx: '上游 5xx',
    upstream_connection_error: '上游连接失败',
    upstream_invalid_response: '上游响应异常',
    upstream_timeout: '上游超时',
    validation_error: '参数校验失败',
  },
  errorDescription: '请稍后重试，或检查当前管理员是否仍有模型网关访问权限。',
  errorDescriptionWithDetail: '后端返回：{{detail}}',
  errorTitle: '调用日志加载失败',
  failureStages: {
    auth: '认证',
    internal: '内部处理',
    internal_model_eval: '内部模型评测',
    internal_model_runtime: '内部模型运行',
    model_resolution: '模型解析',
    probe: '模型探针',
    protocol_check: '协议检查',
    quota_precheck: 'Quota 预检查',
    stream_runtime: '流式运行',
    upstream_decode: '上游解码',
    upstream_dispatch: '上游调用',
  },
  fallback: {
    none: '未触发',
    triggered: '已触发',
  },
  filters: {
    allErrorCategories: '所有错误分类',
    allFailureStages: '所有失败阶段',
    allFallback: '所有 fallback',
    allProviders: '所有供应商',
    allStatuses: '所有状态',
    advanced: '更多筛选',
    advancedLabel: '打开更多筛选，当前已启用 {{count}} 个高级筛选',
    clear: '清空筛选',
    clearAdvanced: '清空高级筛选',
    errorCategoryLabel: '筛选错误分类',
    failureStageLabel: '筛选失败阶段',
    fallbackLabel: '筛选 fallback',
    keyIdLabel: '筛选密钥 UUID',
    keyIdPlaceholder: '分发密钥 UUID',
    modelLabel: '筛选模型名称',
    modelPlaceholder: '模型名称',
    providerLabel: '筛选供应商',
    requestIdLabel: '搜索 Request ID',
    requestIdPlaceholder: 'Request ID',
    statusLabel: '筛选调用状态',
  },
  pagination: {
    next: '下一页',
    pageSize: '{{count}} 条/页',
    previous: '上一页',
  },
  providers: {
    anthropic: 'Anthropic',
    deepseek: 'DeepSeek',
    gemini: 'Gemini',
    glm: 'GLM',
    kimi: 'Kimi',
    minimax: 'MiniMax',
    openai: 'OpenAI',
    qwen: 'Qwen',
    xai: 'xAI',
  },
  quota: {
    none: '未触发',
    triggered: '已触发',
  },
  retry: '重试',
  status: {
    failure: '失败',
    success: '成功',
  },
  summary: {
    avgLatency: '平均延迟',
    cost: '总成本',
    requests: '总请求',
    successRate: '成功率',
    totalTokens: '总 tokens',
  },
  table: {
    actions: '操作',
    cost: '成本',
    error: '错误',
    errorCategory: '错误分类',
    failureStage: '失败阶段',
    fallback: 'Fallback',
    key: '密钥',
    latency: '延迟',
    provider: '供应商',
    quota: 'Quota',
    requestId: 'Request ID',
    route: '模型路由',
    source: '来源',
    startedAt: '调用时间',
    status: '状态',
    statusCode: '状态码',
    tokens: 'Tokens',
  },
  timeRange: {
    apply: '应用',
    ariaLabel: '筛选时间范围',
    close: '关闭',
    customRange: '自定义范围',
    dialogLabel: '选择调用日志时间范围',
    from: '开始时间',
    compactPresets: {
      custom: '自定义',
      last24h: '近24小时',
      last30d: '近30天',
      last7d: '近7天',
    },
    presets: {
      custom: '自定义范围',
      last24h: '最近 24 小时',
      last30d: '最近 30 天',
      last7d: '最近 7 天',
    },
    quickRanges: '快速范围',
    to: '结束时间',
    valueTitle: '{{from}} 至 {{to}}',
  },
  title: '调用日志',
  workspaceLabel: '模型调用日志工作区',
}

export default adminModelCallLogs
